"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRunPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../../base-utils/map-creator");
var font_info_cache_1 = require("../../../../../../core/model/caches/hashed-caches/font-info-cache");
var character_property_descriptor_1 = require("../../../../../../core/model/character/character-property-descriptor");
var destination_1 = require("../../../destination");
var inner_default_run_properties_destination_1 = require("./inner-default-run-properties-destination");
var DefaultRunPropertiesDestination = (function (_super) {
    tslib_1.__extends(DefaultRunPropertiesDestination, _super);
    function DefaultRunPropertiesDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DefaultRunPropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return DefaultRunPropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    DefaultRunPropertiesDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var properties;
            return tslib_1.__generator(this, function (_a) {
                _super.prototype.processElementOpen.call(this, reader);
                properties = this.data.documentModel.defaultCharacterProperties;
                properties.setValue(character_property_descriptor_1.CharacterPropertyDescriptor.size, 10);
                properties.setValue(character_property_descriptor_1.CharacterPropertyDescriptor.fontInfo, this.data.documentModel.cache.fontInfoCache.getItemByName(font_info_cache_1.FontInfoCache.fallbackFontName));
                return [2];
            });
        });
    };
    DefaultRunPropertiesDestination.handlerTable = new map_creator_1.MapCreator()
        .add('rPr', function (data) { return new inner_default_run_properties_destination_1.InnerDefaultRunPropertiesDestination(data, data.documentModel.defaultCharacterProperties); })
        .get();
    return DefaultRunPropertiesDestination;
}(destination_1.ElementDestination));
exports.DefaultRunPropertiesDestination = DefaultRunPropertiesDestination;
